<template>
  <page :title="i18n.title">
    <div v-if="second > 0" class="result-loading-warp">
      <div>
        <img class="loading-img" src="@/assets/imgs/loading.gif" alt="" />
      </div>
      <div class="loading-title">
        {{ i18n.loading_title }}
      </div>
      <div class="loading-tips">
        {{ i18n.loading_tips }}
      </div>
    </div>
    <div v-else-if="order">
      <div class="result-modal-head">
        <img src="../../assets/imgs/success.png">
        <div>{{ i18n.msg_success }}</div>
      </div>
      <div class="result-modal-warp">
        <van-image
          width="7rem"
          fit="contain"
          :src="require('assets/imgs/device2.png')"
        />
      </div>
    </div>
    <result-msg v-else-if="loading" type="100" :text="i18n.msg_result_loading" />
    <result-msg v-else-if="error" type="500" :text="error" @click="onReload" />
    <result-msg v-else />
  </page>
</template>

<script>
import { mapState } from 'vuex'
import CircleProgress from '../../components/result/circle_progress.vue'
import ResultMsg from '../../components/result/msg.vue'
import { ORDER_CHECK, ORDER_TEMP } from '../../apis/cabinet.js'
import { PAYPAL_EXC_PAY, MPESA_PAYCONFIRM, PAY_CONFIRM, PAYSTACK_CONFIRM } from '../../apis/payment.js'
let loadingTimer
export default {
  components: {
    ResultMsg
    // CircleProgress
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    paypal (val, oldVal) {
      if (val && val.paymentId) {
        this.onPayExec()
      }
    }
  },
  computed: {
    ...mapState(['cabinet', 'payType']),
    i18n () {
      return this.$t('result')
    },
    i18nMsg () {
      return this.$t('msg')
    },
    percent () {
      return (this.second % 30) * 3.334
    },
    secondFmt () {
      return (this.second + 0.45).toFixed(0)
    },
    shopDesc () {
      return `${this.i18n.price_info}`.format(this.order)
    },
    infoTips1 () {
      return `${this.i18n.tips_1}`.format(this.order)
    },
    infoTips2 () {
      return this.i18n.tips_2
    }
    // imgSrc () {
    //   if (this.order && this.order.shebei) {
    //     return require(`../../assets/imgs/cabinet${this.order.shebei}_${this.order.number}.gif`)
    //   } else {
    //     return require(`../../assets/imgs/cabinet.png`)
    //   }
    // }
  },
  data () {
    return {
      loading: false,
      error: '',
      paypal: null,
      order: null,
      tradeNo: '',
      second: 0,
      payMode: 'paypal'
    }
  },
  methods: {
    startTimer () {
      if (this.second === 0) {
        loadingTimer = setInterval(() => {
          this.second += 0.1
        }, 100)
      }
    },
    stopTimer () {
      clearInterval(loadingTimer)
      this.second = 0
    },
    onInput (val) {
      this.$emit('input', val)
    },
    onReload () {
      if (this.tradeNo) {
        this.checkOrder(this.tradeNo, this.payMode)
      } else {
        this.onPayExec()
      }
    },
    onPayExec () {
      this.startTimer()
      this.loading = true
      this.$post(
        PAYPAL_EXC_PAY,
        {
          ...this.paypal
        },
        resp => {
          this.loading = false
          this.error = ''
          const data = resp.data
          if (data.out_trade_no) {
            if (data.pay_type === 'CZ') {
              this.$confirm({
                title: this.i18nMsg.title,
                content: this.i18nMsg.success_payment,
                confirmText: this.i18nMsg.confirm,
                showCancel: false
              }).then(() => {
                this.$router.push('/mine')
              })
            } if (data.pay_type === 'YJ') {
              this.checkOrder(data.out_trade_no)
            }
          }
        },
        error => {
          if (this.second < 30) {
            this.onPayExec()
          } else {
            this.stopTimer()
            this.loading = false
            this.error = error
            console.log(error)
          }
        }
      )
    },
    checkOrder (tradeNo, payMode = 'paypal', payType = '') {
      if (!payType) {
        this.startTimer()
      }
      // if (payMode === 'mpesa') {
      //   this.onSMSCheckOrder(tradeNo, payMode, payType)
      //   return
      // }
      this.tradeNo = tradeNo
      this.loading = true
      this.$post(
        `${ORDER_CHECK}/${tradeNo}/${payMode}`,
        {},
        resp => {
          if (payType === 'FK') {
            this.$router.replace({ path: '/pastOrder' })
          } else if (payType === 'CZ') {
            this.$router.replace({ path: '/wallet' })
          }
          this.loading = false
          this.error = ''
          this.stopTimer()
          this.order = resp
        },
        error => {
          if (payType === 'FK') {
            setTimeout(() => {
              this.$router.replace({ path: '/pastOrder' })
            }, 1500)
          } else if (payType === 'CZ') {
            setTimeout(() => {
              this.$router.replace({ path: '/wallet' })
            }, 1500)
          } else if (error === '正在请求中' || error === 'Processing') {
            setTimeout(() => {
              this.checkOrder(tradeNo, payMode, payType)
            }, 1000)
          } else {
            this.stopTimer()
            this.loading = false
            this.error = error
            console.log(error)
          }
        }
      )
    },
    // Espees支付确认
    onN1coConfirm(payMode) {
      const { tradeNo = "", outTradeNo = "", type = "" } = this.$route.query
      const datas = {
        outTradeNo: outTradeNo
      }
      this.startTimer()
      this.$Request("get", PAY_CONFIRM, datas)
        .then((resp) => {
          if (type === "CZ" || resp.data.type === "CZ") {
            setTimeout(() => {
              this.$router.replace({ path: "/wallet" })
            }, 1500)
            // 付款订单 RENT
          } else if (type === "RENT") {
            this.$router.replace({ path: "/pastOrder" })
          } else {
            this.checkOrder(outTradeNo, payMode, type)
          }
        })
        .catch((error) => {
          this.error = error
          this.stopTimer()
        })
    },
    onPayStackConfirm (outTradeNo) {
      this.startTimer()
      this.loading = true
      this.$get(
        `${PAYSTACK_CONFIRM}?outTradeNo=${outTradeNo}`,
        {},
        (resp) => {
          console.log('this.payType', this.payType)
          if (this.payType === "YJ") {
            setTimeout(() => {
              this.onBorrow()
            }, 2000)
          } else if (this.payType === "FK") {
            this.$router.replace({ path: `/pastOrder` })
            this.loading = false
            this.error = ""
            this.order = resp
            this.stopTimer()
          } else if (this.payType === "CZ") {
            this.$router.replace({ path: "/wallet" })
            this.loading = false
            this.error = ""
            this.order = resp
            this.stopTimer()
          }
        },
        (error) => {
          this.stopTimer()
          this.loading = false
          this.error = error
          console.log(error)
        }
      )
    },
    onBorrow() {
      this.$get(
        `${ORDER_TEMP}?qrcode=${this.cabinet.cabinetID}`,
        {},
        (resp) => {
          console.log(resp)
          if (resp.data.outTradNo) {
            this.checkOrder(resp.data.outTradNo, 'PayStack', 'YJ')
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              showCancel: false
            })
          }
        },
        (error) => {
          console.log(error)
          this.$toast(error)
        }
      )
    }
  },
  created () {
    console.log('result route:', this.$route.query)
    let { paymentId, token, PayerID, tradeNo, payMode, payType, outTradeNo, type } = this.$route.query
    this.payMode = payMode
    if (payMode === 'N1co' || payMode === 'Alif_Pay') {
      this.onN1coConfirm(payMode)
    } else if (payType === 'PayStack') {
      this.onPayStackConfirm(outTradeNo)
    } else if (payMode === 'PayZone' && !!outTradeNo) {
      payType = type === 'RENT' ? 'FK' : ''
      this.checkOrder(outTradeNo, payMode, payType)
    } else if (tradeNo) {
      this.checkOrder(tradeNo, payMode, payType)
    } else {
      this.paypal = {
        paymentId,
        token,
        payerId: PayerID
      }
    }
  },
  destroyed () {
    this.$store.commit('cabinet', null)
    this.$store.commit('qrcode', '')
    this.$store.commit('zhcode', '')
  }
}
</script>

<style lang="less">
.result-loading-warp {
  min-height: 100vh;
  background-color: #fff;
  .loading-img {
    width: 500px;
    display: block;
    margin: 0 auto;
  }
  .loading-title {
    font-size: 48px;
    text-align: center;
    padding: 120px 0 12px;
    font-weight: 600;
  }
  .loading-tips {
    font-size: 36px;
    text-align: center;
  }
}
.result-modal-head {
  padding: 40px 32px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.result-modal-warp {
  display: flex;
  justify-content: center;
}

.result-modal-head img {
  width: 56px;
  height: 56px;
}

.result-modal-head div {
  padding-left: 10px;
}

.result-modal-cabinet {
  padding-bottom: 32px;
  width: 100%;
  text-align: center;
  background: #FFFFFF;
}

.result-modal-cabinet img {
  width: 360px;
  margin: 0 auto;
  height: 360px;
}

.result-modal-info {
  // background: rgba(255,255,255,1);
  // background-img: url(../../static/imgs/card_bg.png);
  // background-size: 100% 100%;
  background: rgba(255, 255, 255, 1);
  padding: 0 32px;

  &-warp {
    box-shadow: 0px 2px 16px 0px rgba(153, 153, 153, 0.32);
    border-radius: 24px;
    padding: 32px 32px 0;
    word-break: normal;
  }

  & .title {
    font-size: 36px;
    font-weight: 500;
    color: rgba(52, 125, 255, 1);
    padding: 8px 0;
  }

  & .desc {
    font-size: 28px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }
}

.result-modal-btn {
  display: flex;
  padding: 40px 16px;
}

.result-modal-btn .help-btn {
  flex: 1;
  height: 80px;
  line-height: 80px;
  border-radius: 48px;
  text-align: center;
  border: 2px solid rgba(52, 125, 255, 1);
  font-size: 28px;
  font-weight: 500;
  color: rgba(52, 125, 255, 1);
  margin: 0 14px;
}

.result-modal-remark {
  font-size: 28px;
  padding: 40px 32px;
  color: rgba(102, 102, 102, 1);

  & .highlight {
    font-size: 50px;
  }
}

.result-modal-remark .bold {
  font-size: 32px;
  color: rgba(51, 51, 51, 1);
}

.result-modal-remark div {
  padding: 8px;
}

.result-loading {
  &.circle {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &-warp {
    background: #FFFFFF;
    padding: 30px 0;
  }

  & span {
    position: absolute;
    font-size: 70px;
    color: #F13453;
  }

  &-tips {
    text-align: center;
    font-size: 28px;
    color: #347DFF;
  }
}
</style>
